import { Center, Heading, useToast, VStack } from "@chakra-ui/react";
import { AdminStoryCategoriesEndpoints, fetcher } from "@olagg/api-hooks";
import { useNavigate } from "react-router-dom";
import Form from "./Form";

const Create = () => {
    const toast = useToast();
    const navigate = useNavigate();

    const onSubmit = async (data: FormData) =>
        fetcher(AdminStoryCategoriesEndpoints.create(data))
            .then(() => {
                toast({
                    title: 'Categoría creada',
                    status: 'success',
                    duration: 3000,
                    position: 'top-right',
                    isClosable: true,
                });
                navigate('/stories');
            })
            .catch(e => {
                console.error(e);
                toast({
                    title: 'Error al crear la categoría: ' + e.errors,
                    position: 'top-right',
                    status: 'error',
                    duration: 3000,
                    isClosable: true,
                });
            });

    return (
        <>
            <Center w={'full'} pb={4}>
                <VStack color={'white'}>
                    <Heading my={2}>
                        Crear Categoría
                    </Heading>
                    <Form onSubmit={onSubmit} />
                </VStack>
            </Center>
        </>
    )
};

export default Create;